export enum AzeiteOrOleoProductionStatus {
  READY_TO_PROCESS = 'ready_to_process',
  COMPLETE = 'complete',
}

export function getAzeiteOrOleoProductionLabel({
  status,
  azeiteOrOleoName,
  shortName,
  helperText,
}: {
  status: AzeiteOrOleoProductionStatus;
  azeiteOrOleoName?: string;
  shortName?: boolean;
  helperText?: boolean;
}): string {
  if (shortName) {
    switch (status) {
      case AzeiteOrOleoProductionStatus.READY_TO_PROCESS:
        return 'Em produção';
      case AzeiteOrOleoProductionStatus.COMPLETE:
        return 'Finalizada';
    }
  }

  if (helperText) {
    switch (status) {
      case AzeiteOrOleoProductionStatus.READY_TO_PROCESS:
        return azeiteOrOleoName
          ? `O coco já foi quebrado e as amêndoas foram pesadas. Pronto para produzir o ${azeiteOrOleoName}!`
          : 'O coco já foi quebrado e as amêndoas foram pesadas. Pronto para produzir!';
      case AzeiteOrOleoProductionStatus.COMPLETE:
        return azeiteOrOleoName
          ? `A produção já terminou e o ${azeiteOrOleoName} foi armazenado!`
          : 'A produção já terminou e foi armazenada!';
    }
  }

  switch (status) {
    case AzeiteOrOleoProductionStatus.READY_TO_PROCESS:
      return 'Amêndoa já pesada para produção';
    case AzeiteOrOleoProductionStatus.COMPLETE:
      return 'Produção finalizada e armazenada';
  }
}
